export default "__VITE_ASSET__455f27e4__"